module.exports = __webpack_public_path__ + "img/categories_memoire_mobile_all.7310874.webp";